import { FC, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Badge from '@mui/material/Badge/Badge';
import Button from '@mui/material/Button/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import Stack from '@mui/material/Stack/Stack';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import { GridApiPro } from '@mui/x-data-grid-pro';

import Action from '../types/action.type';

type DropdownProps = Extract<Action, { type: 'dropdown' }> & {
  apiRef: React.MutableRefObject<GridApiPro>;
};

const Dropdown: FC<DropdownProps> = ({ trigger, dropdown, apiRef }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <div>
      <Tooltip title={trigger.tooltipProps?.title} {...trigger.tooltipProps}>
        <Badge {...trigger.badgeProps}>
          <Button
            id='button'
            aria-haspopup='true'
            aria-controls={open ? 'menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            variant='contained'
            disableElevation
            endIcon={<KeyboardArrowDownIcon />}
            {...trigger.button}
            onClick={(e) => {
              handleClick(e);
              trigger.button.onClick?.(apiRef);
            }}
          >
            {trigger.button.label}
          </Button>
        </Badge>
      </Tooltip>

      <Menu
        elevation={2}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        id='menu'
        MenuListProps={{
          'aria-labelledby': 'button',
          'sx': { minWidth: 150 },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Stack>
          {dropdown.map((item) => (
            <Tooltip
              key={item.button.label}
              title={item.tooltipProps?.title}
              {...item.tooltipProps}
            >
              <Badge {...item.badgeProps}>
                <MenuItem
                  sx={{ width: '100%' }}
                  disabled={item.button.disabled}
                  onClick={() => {
                    item.button.onClick?.(apiRef);
                    handleClose();
                  }}
                >
                  {item.button.label}
                </MenuItem>
              </Badge>
            </Tooltip>
          ))}
        </Stack>
      </Menu>
    </div>
  );
};

export default Dropdown;
